import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(legacy)/(auth)/sign-up/(funnel)/register/page.tsx");
